<template>
  <div>
    <wrapper-preview-category customClass="section-preview_lk">
      <card-prin-document-btn
        :name="`Выгрузка МПГ свод ${calcDateNowMethod()}`"
        :link="`/api/${selectedYear}/report/excel_svod_all`"
        :token="getUserAccessToken"
        fileTypeName=".xlsx"
        fileType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        type="blue">
        Общая выгрузка
      </card-prin-document-btn>
      <card-prin-document-btn
        :name="`Выгрузка контактов ${calcDateNowMethod()}`"
        :link="`/api/${selectedYear}/report/excel_contacts_block`"
        :token="getUserAccessToken"
        fileTypeName=".xlsx"
        fileType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        type="blue"
        class="ml-3">
        Выгрузка контактов
      </card-prin-document-btn>
      <v-row>
        <v-col cols="4">
          <v-autocomplete :items="filterList" v-model="filterValue"> </v-autocomplete>
        </v-col>
        <v-col>
          <v-text-field :label="'Фильтр'" class="mb-4" v-model="filter"></v-text-field>
        </v-col>
      </v-row>
      <grid-table
        :data-rows="chosenData"
        :headers="tableHeaders"
        :headers-for-rows="tableHeaders"
        :loading-data="tableData.loading"
        :num-cols="5"
        style="height: 700px"
        max-table-height="700px">
        <template #block="{ row }">
          <template>
            <card-prin-document-btn
              :name="`Выгрузка МПГ орг ${row.id} на ${calcDateNowMethod()}`"
              :link="`/api/${selectedYear}/report/excel_svod/${row.id}`"
              :token="getUserAccessToken"
              fileTypeName=".xlsx"
              icon
              fileType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
              <v-icon size="25" color="primary">mdi-microsoft-excel</v-icon>
            </card-prin-document-btn>
            <v-btn @click="authAs(row.id, row.name)" class="" icon>
              <v-icon size="25" color="primary">mdi-login</v-icon>
            </v-btn>
            <v-menu
              :close-on-content-click="false"
              :nudge-right="40"
              min-width="290px"
              offset-y
              transition="scale-transition">
              <template #activator="{ on, attrs }">
                <v-btn class="" v-on="on" v-bind="attrs" icon>
                  <v-icon size="25" color="primary">mdi-lock</v-icon>
                </v-btn>
              </template>
              <template>
                <v-card>
                  <v-card-text v-if="row.mpgBlock">
                    <v-row>
                      <v-col> Блокировка все бюджетники, БСМ и ассистентура</v-col>
                      <v-col>
                        <v-btn
                          :loading="
                            loadingBlockEnterData.value === true &&
                            loadingBlockEnterData.id === row.id
                          "
                          @click="unblock(row, 'blockBsma', 'BSMA', row.mpgBlock.blockBsma)"
                          class="white__v-btn">
                          <span>{{
                            row.mpgBlock.blockBsma ? 'Рaзблокировать' : 'Заблокировать ввод'
                          }}</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col> Блокировка все бюджетники, аспирантура</v-col>
                      <v-col>
                        <v-btn
                          :loading="
                            loadingBlockEnterData.value === true &&
                            loadingBlockEnterData.id === row.id
                          "
                          @click="
                            unblock(
                              row,
                              'blockPostgraduate',
                              'POSTGRADUATE',
                              row.mpgBlock.blockPostgraduate,
                            )
                          "
                          class="white__v-btn">
                          <span>{{
                            row.mpgBlock.blockPostgraduate ? 'Рaзблокировать' : 'Заблокировать ввод'
                          }}</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col> Блокировка все бюджетники, ординатура</v-col>
                      <v-col>
                        <v-btn
                          :loading="
                            loadingBlockEnterData.value === true &&
                            loadingBlockEnterData.id === row.id
                          "
                          @click="
                            unblock(
                              row,
                              'blockInternship',
                              'INTERNSHIP',
                              row.mpgBlock.blockInternship,
                            )
                          "
                          class="white__v-btn">
                          <span>{{
                            row.mpgBlock.blockInternship ? 'Рaзблокировать' : 'Заблокировать ввод'
                          }}</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col> Блокировка платники, БСМ</v-col>
                      <v-col>
                        <v-btn
                          :loading="
                            loadingBlockEnterData.value === true &&
                            loadingBlockEnterData.id === row.id
                          "
                          @click="
                            unblock(row, 'blockPaidBsm', 'PAID_BSM', row.mpgBlock.blockPaidBsm)
                          "
                          class="white__v-btn">
                          <span>{{
                            row.mpgBlock.blockPaidBsm ? 'Рaзблокировать' : 'Заблокировать ввод'
                          }}</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col> Блокировка платники, ассистентура</v-col>
                      <v-col>
                        <v-btn
                          :loading="
                            loadingBlockEnterData.value === true &&
                            loadingBlockEnterData.id === row.id
                          "
                          @click="
                            unblock(
                              row,
                              'blockPaidAssist',
                              'PAID_ASSIST',
                              row.mpgBlock.blockPaidAssist,
                            )
                          "
                          class="white__v-btn">
                          <span>{{
                            row.mpgBlock.blockPaidAssist ? 'Рaзблокировать' : 'Заблокировать ввод'
                          }}</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col> Блокировка платники, аспирантура</v-col>
                      <v-col>
                        <v-btn
                          :loading="
                            loadingBlockEnterData.value === true &&
                            loadingBlockEnterData.id === row.id
                          "
                          @click="
                            unblock(
                              row,
                              'blockPaidPostgraduate',
                              'PAID_POSTGRADUATE',
                              row.mpgBlock.blockPaidPostgraduate,
                            )
                          "
                          class="white__v-btn">
                          <span>{{
                            row.mpgBlock.blockPaidPostgraduate
                              ? 'Рaзблокировать'
                              : 'Заблокировать ввод'
                          }}</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col> Блокировка платники, ординатура</v-col>
                      <v-col>
                        <v-btn
                          :loading="
                            loadingBlockEnterData.value === true &&
                            loadingBlockEnterData.id === row.id
                          "
                          @click="
                            unblock(
                              row,
                              'blockPaidInternship',
                              'PAID_INTERNSHIP',
                              row.mpgBlock.blockPaidInternship,
                            )
                          "
                          class="white__v-btn">
                          <span>{{
                            row.mpgBlock.blockPaidInternship
                              ? 'Рaзблокировать'
                              : 'Заблокировать ввод'
                          }}</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col> Блокировка ввода дат заявлений</v-col>
                      <v-col>
                        <v-btn
                                :loading="
                            loadingBlockEnterData.value === true &&
                            loadingBlockEnterData.id === row.id
                          "
                                @click="
                            unblock(
                              row,
                              'blockAppDeadline',
                              'APPDEADLINE',
                              row.mpgBlock.blockAppDeadline,
                            )
                          "
                                class="white__v-btn">
                          <span>{{
                              row.mpgBlock.blockAppDeadline
                                  ? 'Рaзблокировать'
                                  : 'Заблокировать ввод'
                            }}</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col> Блокировка ЦК БСМ и Ассист</v-col>
                      <v-col>
                        <v-btn
                            :loading="
                            loadingBlockEnterData.value === true &&
                            loadingBlockEnterData.id === row.id
                          "
                            @click="
                            unblock(
                              row,
                              'blockTargetQuotaBsma',
                              'TARGET_QUOTA_BSMA',
                              row.mpgBlock.blockTargetQuotaBsma,
                            )
                          "
                            class="white__v-btn">
                          <span>{{
                              row.mpgBlock.blockTargetQuotaBsma
                                  ? 'Рaзблокировать'
                                  : 'Заблокировать ввод'
                            }}</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col> Блокировка ЦК Аспирантура</v-col>
                      <v-col>
                        <v-btn
                            :loading="
                            loadingBlockEnterData.value === true &&
                            loadingBlockEnterData.id === row.id
                          "
                            @click="
                            unblock(
                              row,
                              'blockTargetQuotaPostgraduate',
                              'TARGET_QUOTA_POSTGRADUATE',
                              row.mpgBlock.blockTargetQuotaPostgraduate,
                            )
                          "
                            class="white__v-btn">
                          <span>{{
                              row.mpgBlock.blockTargetQuotaPostgraduate
                                  ? 'Рaзблокировать'
                                  : 'Заблокировать ввод'
                            }}</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col> Блокировка ЦК Интернатура</v-col>
                      <v-col>
                        <v-btn
                            :loading="
                            loadingBlockEnterData.value === true &&
                            loadingBlockEnterData.id === row.id
                          "
                            @click="
                            unblock(
                              row,
                              'blockTargetQuotaInternship',
                              'TARGET_QUOTA_INTERNSHIP',
                              row.mpgBlock.blockTargetQuotaInternship,
                            )
                          "
                            class="white__v-btn">
                          <span>{{
                              row.mpgBlock.blockTargetQuotaInternship
                                  ? 'Рaзблокировать'
                                  : 'Заблокировать ввод'
                            }}</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col> Блокировка ввода ДВИ</v-col>
                      <v-col>
                        <v-btn
                            :loading="
                            loadingBlockEnterData.value === true &&
                            loadingBlockEnterData.id === row.id
                          "
                            @click="
                            unblock(
                              row,
                              'blockDviNumber',
                              'DVI_NUMBER',
                              row.mpgBlock.blockDviNumber,
                            )
                          "
                            class="white__v-btn">
                          <span>{{
                              row.mpgBlock.blockDviNumber
                                  ? 'Рaзблокировать'
                                  : 'Заблокировать ввод'
                            }}</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
            </v-menu>
          </template>
        </template>
      </grid-table>
      <v-pagination
        :length="length"
        :total-visible="10"
        circle
        class="mt-5"
        v-model="page"></v-pagination>
    </wrapper-preview-category>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import WrapperPreviewCategory from '@/components/cards/WrapperPreviewCategory';
  import GridTable from '@/components/table/GridTable';
  import CardPrinDocumentBtn from '@/components/UI/cardPrinDocumentBtn';
  import headers from '@/newApplication/views/Admin/headers';
  import { getSprOrgForAdmin } from '@/API/spr';
  import { changeBlockStatus } from '@/API/user';
  import { calcDateNow } from '@/utils/dateNow';
  import axios from "axios";
  export default {
    name: 'orgTableAdmin',
    components: { GridTable, WrapperPreviewCategory, CardPrinDocumentBtn },
    data: () => ({
      selectedYear: '2024',
      tableHeaders: headers,
      tableData: {
        loading: false,
        error: null,
        data: [],
      },
      loadingBlockEnterData: { value: true, id: null },
      filter: null,
      filterValue: 'name',
      filterList: [
        { value: 'name', text: 'Название орг' },
        { value: 'id', text: 'ID орг' },
      ],
      page: 1,
      countRows: 15,
    }),
    computed: {
      ...mapGetters({ getSelectedYear: 'selectedYear' }),
      ...mapGetters('keycloak', {
        getUserAccessToken: 'getUserAccessToken',
      }),
      getYear() {
        if (this.getSelectedYear) return this.getSelectedYear;
        return this.selectedYear;
      },
      getOrgId() {
        if (this.getFakeUser) return this.getFakeUser.id;
        return this.getUser.orgID;
      },
      filteredData() {
        return this.tableData.data
          .filter((el) => {
            if (this.filter)
              return String(el[this.filterValue]).toLowerCase().includes(this.filter.toLowerCase());
            else return el;
          })
          .sort((el, el2) => {
            return !!el.block === true && !!el2.block === false
              ? -1
              : !!el.block === false && !!el2.block === true
              ? 1
              : 0;
          });
      },
      chosenData() {
        return this.filteredData.slice(
          (this.page - 1) * this.countRows,
          this.page * this.countRows,
        );
      },
      length() {
        const buf = Number.parseInt(this.filteredData.length / this.countRows);
        if (buf * this.countRows < this.filteredData.length) return buf + 1;
        else return buf;
      },
    },
    created() {
      this.getOrgTableData();
      if (this.getSelectedYear) this.selectedYear = this.getSelectedYear;
    },
    watch: {
      getSelectedYear() {
        this.getOrgTableData();
        if (this.getSelectedYear) this.selectedYear = this.getSelectedYear;
      },
    },
    methods: {
      ...mapActions('notification', { setNotification: 'setNotification' }),
      ...mapActions('keycloak', { initFakeUser: 'initFakeUser' }),
      calcDateNowMethod() {
        return calcDateNow();
      },
      authAs(id, name) {
        this.initFakeUser({
          role: 'ORGANIZATION_ROLE',
          id: id,
          name: name ?? '',
        });
        axios.defaults.headers.common['X-Auth-As'] = id;
        localStorage.setItem('fakeUser', id)
        this.$router.push({ name: 'Contacts' });
      },
      async getOrgTableData() {
        this.tableData.loading = true;
        this.tableData.error = null;
        try {
          const res = await getSprOrgForAdmin(this.getYear);
          if (res && res.length) {
            this.tableData.data = res;
          } else {
            this.tableData.data = [];
            this.tableData.error = res;
          }
          this.tableData.loading = false;
        } catch (e) {
          this.tableData.error = e;
          this.tableData.data = [];
          this.tableData.loading = false;
        }
      },
      async unblock(row, variable, type, currentStatus) {
        this.loadingBlockEnterData = { value: true, id: row.id };
        try {
          const res = await changeBlockStatus(currentStatus, row.id, type, this.getYear);
          if (res) {
            this.loadingBlockEnterData = { value: false, id: row.id };
            const changedRow = this.tableData.data.find((el) => el.id === row.id);
            if (changedRow) changedRow.mpgBlock[variable] = res[variable];
          }
        } catch (e) {
          this.loadingBlockEnterData = { value: false, id: row.id };
        }
      },
    },
  };
</script>

<style lang="sass" scoped>
  .section-preview__header
    font-size: 24px
    font-weight: bold
    margin: 16px 0
    color: #334D6E
</style>
